import { Download, Loader2 } from "lucide-react";

type DownloadButtonProps = {
  disabled: boolean;
  isExporting: boolean;
  onDownload: () => void;
};

export function DownloadButton({
  disabled,
  isExporting,
  onDownload,
}: DownloadButtonProps) {
  return (
    <button
      type="button"
      disabled={disabled || isExporting}
      onClick={onDownload}
      className="inline-flex min-h-10 items-center justify-center gap-2 rounded-lg bg-amber px-4 py-2 text-sm font-bold text-slate-950 shadow-sm transition hover:bg-[#e6972d] disabled:cursor-not-allowed disabled:opacity-55"
    >
      {isExporting ? (
        <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
      ) : (
        <Download className="h-4 w-4" aria-hidden="true" />
      )}
      {isExporting ? "Exporting..." : "Download Image"}
    </button>
  );
}
